import { Skeleton } from 'src/components/UI/Skeleton';

export function HeaderSkeleton() {
  return <Skeleton h={'80px'} w={'40%'} />;
}
